"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelect = void 0;
const react_1 = __importStar(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const Wrapper_1 = require("../Wrapper");
const DropdownArrow_1 = require("./DropdownArrow");
require("./index.scss");
const MultiSelect = (props) => {
    const { dropdownContent, fieldContent, additionClassNames, modificators, hidden, ...formFieldProps } = props;
    const classNames = (0, classFunctions_1.getClassNames)('multi-select', undefined, additionClassNames);
    const [open, setOpen] = (0, react_1.useState)(false);
    const toggleOpen = (0, react_1.useCallback)(() => {
        setOpen(!open);
    }, [open]);
    const direction = (0, react_1.useMemo)(() => open ? 'top' : 'bottom', [open]);
    const multiselectRef = (0, react_1.useRef)(null);
    react_1.default.useEffect(() => {
        const handleClickOutside = (e) => {
            var _a;
            if (!((_a = multiselectRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    if (hidden)
        return null;
    return (react_1.default.createElement("div", { ref: multiselectRef, className: classNames },
        react_1.default.createElement(Wrapper_1.FormFieldWrapper, { ...formFieldProps, addonWidth: '10px', onClick: toggleOpen, addon: (react_1.default.createElement(DropdownArrow_1.DropdownArrow, { direction: direction })), modificators: modificators, slot: react_1.default.createElement("div", { className: 'multi-select__field-container' }, fieldContent) }),
        open && (react_1.default.createElement("div", { className: 'multi-select__dropdown-container' }, dropdownContent))));
};
exports.MultiSelect = MultiSelect;
//# sourceMappingURL=index.js.map